import * as React from 'react';
import { Link as PortalLink } from 'gatsby';
//import { LocalizedLink as PortalLink } from 'gatsby-theme-i18n';
import isAbsoluteUrl from 'is-absolute-url';

const AnchorTag = ({ children: link, ...props }) => {
  if (link) {
    if (isAbsoluteUrl(props.href)) {
      return (
        <a href={props.href} target="_blank" rel="noopener noreferrer">
          {link}
        </a>
      );
    } else {
      return (
        <PortalLink to={props.href} {...props}>
          {link}
        </PortalLink>
      );
    }
  } else {
    return null;
  }
};

export default AnchorTag;
